import { Vue } from "vue-property-decorator";
import vuex from "vuex";
import BootstrapVue from "bootstrap-vue";
import * as vuexClass from "vuex-class";
import * as vuePropertyDecorator from "vue-property-decorator";
import * as vueClassComponent from "vue-class-component";
import * as axiosInstance from "@/axios.instance";
import * as V2Mapping from "@sureview/v2-mapping-saas";
import * as vueShortkey from "vue-shortkey";
import * as vueSimplePortal from "@linusborg/vue-simple-portal";
import * as lodash from "lodash";
import AlarmQueueHeader from "@/components/AlarmQueueHeader.vue";
import AlarmQueue from "@/components/AlarmQueue.vue";
import AlarmQueueCCure from "@/components/AlarmQueueCCure.vue";
import AlarmQueueFooter from "@/components/AlarmQueueFooter.vue";
import * as Camera from "@sureview/camera";
import * as v2Dropdown from "@sureview/vuejs-sv-dropdown";
import * as InsightsGraph from "@/components/reports/InsightsGraph.vue";
import vSelect from "vue-select";
import TextHighlight from "vue-text-highlight";
import AreaDetails from "@/components/AreaDetails.vue";
import AreaSchedule from "@/components/areas/AreaSchedule.vue";

import EventQueue from "@/views/EventQueue.vue";

window["vue"] = Vue;
window["vuex"] = vuex;
window["vuex-class"] = vuexClass;
window["vue-property-decorator"] = vuePropertyDecorator;
window["vue-class-component"] = vueClassComponent;
window["bootstrap-vue"] = BootstrapVue;
window["axios.instance"] = axiosInstance;
window["@sureview/v2-mapping-saas"] = V2Mapping;
window["vue-shortkey"] = vueShortkey;
window["@linusborg/vue-simple-portal"] = vueSimplePortal;
window["lodash"] = lodash;
window["@sureview/camera"] = Camera;
window["@sureview/vuejs-sv-dropdown"] = v2Dropdown;

window["insights"] = InsightsGraph;
window["vue-select"] = vSelect;
window["vue-text-highlight"] = TextHighlight;

/*
!!!IMPORTANT!!!
When multiple exposing components of a similar name, use the following format
MainComponentName/SubComponent

There is a weird bug where if you provided the following:
window["alarm-queue-table"] = AlarmQueue;
window["alarm-queue-header"] = AlarmQueueHeader;

Only the first would get loaded
*/

window["event-queue"] = EventQueue;
window["area-details-component"] = AreaDetails;
window["area-schedule"] = AreaSchedule;
